import { render } from "./HeroPage.vue?vue&type=template&id=dcdca4f0&scoped=true"
import script from "./HeroPage.vue?vue&type=script&lang=js"
export * from "./HeroPage.vue?vue&type=script&lang=js"

import "./HeroPage.vue?vue&type=style&index=0&id=dcdca4f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdca4f0"]])

export default __exports__